import { Component, inject, input } from '@angular/core';

import { AnchorDirective, CurrencySymbolPipe } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';

import { MessageType } from '../../../../model/message.model';
import { OptionListService } from '../../../../service/optionList.service';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-transaction-currency',
    templateUrl: 'transaction-currency.component.html',
    imports: [MessageComponent, TranslateModule, CurrencySymbolPipe, AnchorDirective],
})
export class TransactionCurrencyComponent {
    private optionListService = inject(OptionListService);

    defaultCurrency = input.required<string>();

    public get messageType(): typeof MessageType {
        return MessageType;
    }

    gotoAllOptions() {
        this.optionListService.redirectToMainCashier('&type=options');
    }
}
